<template>
  <section class="floor-1">
    <div class="left">
      <h1>{{$t('about.company.h1')}}</h1>
      <p class="company-text">
        &emsp;&emsp;{{$t('about.company.p1')}}
      </p>
      <p class="company-text">
        &emsp;&emsp;{{$t('about.company.p2')}}
      </p>
      <p class="company-text">
        &emsp;&emsp;{{$t('about.company.p3')}}
      </p>
      <p class="company-text">
        &emsp;&emsp;{{$t('about.company.p4')}}
      </p>
      <h2>{{$t('about.company.h2')}}</h2>
      <ul>
        <li>{{$t('about.company.list.first')}}</li>
        <li>{{$t('about.company.list.second')}}</li>
        <li>{{$t('about.company.list.third')}}</li>
        <li>{{$t('about.company.list.fourth')}}</li>
      </ul>
    </div>
    <div class="right">
      <img src="../../assets/images/home/index-car01.webp" alt="" />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
/* 公司简介 */
.floor-1 {
  padding: 48px;
  // height: 857px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.floor-1 .left {
  width: 60%;
  margin-right: 120px;
  // width: 666px;
}

.floor-1 .left h1 {
  color: #ff5d1b;
}
.floor-1 .left .company-text {
  font-size: 13px;
  color: #40404a;
  line-height: 24px;
}
.floor-1 .left h2 {
  color: #ff5d1b;
}
.floor-1 .left ul {
  margin-left: 20px;
  font-size: 13px;
  color: #40404a;
  line-height: 24px;
  list-style-type: circle;
  padding: 0;
}


.floor-1 .right{
  width: 40%;
  img{
    width:100%;
  }
}
</style>